<script setup lang="ts">
const mobileMenuOpen = ref(false);

const navLinks = [
  { title: 'Bil kørekort', to: { name: 'kørekort-bil' } },
  { title: 'Trailer kørekort', to: { name: 'kørekort-trailer' } },
  { title: 'Generhvervelse', to: { name: 'kørekort-generhvervelse' } },
  { title: 'Særlig plan', to: { name: 'kørekort-særlig-plan' } },
  { title: 'Nyheder', to: { name: 'nyheder' } },
];

const slots = defineSlots<{
  bottom?(props: Record<string, any>): any;
}>();
</script>

<template>
  <div class="sticky top-2 left-0 right-0 z-20 mb-8">
    <div class="max-w-6xl mx-auto px-6">
      <div class="flex items-center justify-between rounded-2xl px-6 py-3 bg-white/90 backdrop-blur-md shadow-sm">
        <NuxtLink
          href="/"
          class="flex items-center gap-2 shrink-0"
        >
          <Logo class="h-6 sm:h-8 w-auto" />
          <span
            class="font-semibold text-lg hidden sm:inline"
          >
            Kronborgs Køreskole
          </span>
        </NuxtLink>

        <nav
          class="hidden md:flex items-center gap-6"
        >
          <NuxtLink
            v-for="link in navLinks"
            :key="link.title"
            :to="link.to"
            class="text-sm text-[var(--color-charcoal)]/70 hover:text-[var(--color-charcoal)] transition-colors duration-150"
            active-class="!text-primary-600 font-medium"
          >
            {{ link.title }}
          </NuxtLink>
        </nav>

        <div class="flex items-center gap-4">
          <NuxtLink
            :to="{ name: 'kontakt' }"
            class="hidden sm:inline-flex text-sm text-[var(--color-charcoal)]/70 hover:text-[var(--color-charcoal)] transition-colors duration-150"
            active-class="!text-primary-600 font-medium"
          >
            Kontakt
          </NuxtLink>
          <UButton
            :to="{ name: 'kørekort' }"
            color="primary"
            size="sm"
            label="Tilmeld"
            class="rounded-full"
          />
          <UButton
            variant="ghost"
            icon="i-heroicons-bars-3"
            aria-label="Åbn menu"
            class="md:hidden"
            @click="mobileMenuOpen = true"
          />
        </div>
      </div>

      <div
        v-if="slots.bottom"
        class="pt-6"
      >
        <slot name="bottom" />
      </div>
    </div>

    <USlideover
      v-model:open="mobileMenuOpen"
      title="Menu"
    >
      <template #body>
        <nav class="flex flex-col gap-4">
          <NuxtLink
            v-for="link in navLinks"
            :key="link.title"
            :to="link.to"
            class="text-lg py-2"
            @click="mobileMenuOpen = false"
          >
            {{ link.title }}
          </NuxtLink>
          <NuxtLink
            :to="{ name: 'kontakt' }"
            class="text-lg py-2"
            @click="mobileMenuOpen = false"
          >
            Kontakt
          </NuxtLink>
        </nav>
      </template>
    </USlideover>
  </div>
</template>
